{
  "nl": {
    "imports": {
      "searchPlaceholder": "Naam...",
      "selectedCount": "geen element geselecteerd | {count} geselecteerd | {count} geselecteerd",
      "cancel": "Annuleren",
      "confirm": "Selecteren",
      "discard": {
        "question": "Selectie negeren?",
        "continue": "Verder toevoegen",
        "confirm": "Negeren"
      },
      "tabWithCount": "{label} ({count})",
      "tabMatches": "{label}: geen resultaten | {label}: {count} resultaat | {label}: {count} resultaten",
      "contentList": {
        "leaveFolder": "Terug naar map „{name}“",
        "openFolder": "Map „{name}“ openen",
        "loading": "Inhoud wordt geladen",
        "noResults": {
          "title": "Hier zijn geen resultaten voor „{query}“",
          "text": "Probeer een andere zoekterm"
        }
      },
      "loadMore": "Meer laden",
      "submitFailed": "Importeren mislukt. Probeer het opnieuw.",
      "upload": {
        "addMore": "Meer bestanden selecteren",
        "dropFiles": "Sleep bestanden hierheen of selecteer ze.",
        "interrupted": "Een upload is geannuleerd. Upload het bestand opnieuw.",
        "removeFile": "„{name}” verwijderen",
        "uploaded": "Succesvol geüpload.",
        "wrongType": "Dit bestandstype wordt niet ondersteund."
      },
      "toTeach": {
        "modalTitle": "to teach werkbladen importeren",
        "menuItem": "Importeren van to teach",
        "importedBadge": "Geïmporteerd van to teach",
        "link": {
          "title": "Account koppelen",
          "body": "Je account is nog niet gekoppeld aan to teach. Koppel je account om je to teach-inhoud in fobizz te gebruiken.",
          "confirm": "Naar to teach"
        },
        "worksheets": {
          "tabLabel": "Je to teach-account",
          "accountLink": "Je to teach-account",
          "searchPlaceholder": "to teach werkbladen doorzoeken",
          "empty": "Geen to teach-werkbladen gevonden.",
          "errorLoading": "Je to teach-werkbladen konden niet worden geladen.",
          "batchQueuedFlash": "Je werkblad wordt op de achtergrond geïmporteerd. | Je werkblad wordt op de achtergrond geïmporteerd. | {count} werkbladen worden op de achtergrond geïmporteerd."
        }
      },
      "breadcrumb": {
        "label": "Mappad",
        "more": "Meer mappen weergeven"
      },
      "myContent": {
        "empty": {
          "title": "Je opslag is nog leeg",
          "text": "Geüploade bestanden verschijnen hier."
        },
        "emptyFiltered": {
          "title": "Geen passende inhoud",
          "text": "Pas de filters aan of kies „Alles“."
        },
        "emptyFolder": "Deze map is leeg.",
        "errorLoading": "Je inhoud kon niet worden geladen.",
        "toggleFilters": "Filter tonen",
        "periodLabel": "Tijdsperiode:",
        "noAddableContent": {
          "title": "Hier is niets om toe te voegen",
          "text": "Deze inhoud is al toegevoegd of kan hier niet worden gebruikt."
        }
      }
    }
  }
}
